import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';

const MobileNav = () => {
  const { isAuthenticated, user } = useContext(AuthContext);
  const { t } = useTranslation();
  const location = useLocation();


  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="mobile-nav d-lg-none">
      <div className="mobile-nav-container">
        <Link
          to="/"
          className={`mobile-nav-item ${isActive('/') ? 'active' : ''}`}
        >
          <div className="mobile-nav-icon">
            <i className="fas fa-home"></i>
          </div>
          <span className="mobile-nav-label">{t('nav.home')}</span>
        </Link>

        <Link
          to="/services"
          className={`mobile-nav-item ${isActive('/services') ? 'active' : ''}`}
        >
          <div className="mobile-nav-icon">
            <i className="fas fa-stethoscope"></i>
          </div>
          <span className="mobile-nav-label">{t('nav.services')}</span>
        </Link>

        <Link
          to="/packages"
          className={`mobile-nav-item ${isActive('/packages') ? 'active' : ''}`}
        >
          <div className="mobile-nav-icon">
            <i className="fas fa-box-open"></i>
          </div>
          <span className="mobile-nav-label">{t('nav.packages')}</span>
        </Link>

        {isAuthenticated ? (
          <Link
            to="/analyses"
            className={`mobile-nav-item ${isActive('/analyses') ? 'active' : ''}`}
          >
            <div className="mobile-nav-icon">
              <i className="fas fa-file-medical"></i>
            </div>
            <span className="mobile-nav-label">{t('nav.myAnalyses')}</span>
          </Link>
        ) : (
          <Link
            to="/login"
            className={`mobile-nav-item ${isActive('/login') ? 'active' : ''}`}
          >
            <div className="mobile-nav-icon">
              <i className="fas fa-sign-in-alt"></i>
            </div>
            <span className="mobile-nav-label">{t('nav.login')}</span>
          </Link>
        )}

        <Link
          to="/contact"
          className={`mobile-nav-item ${isActive('/contact') ? 'active' : ''}`}
        >
          <div className="mobile-nav-icon">
            <i className="fas fa-phone"></i>
          </div>
          <span className="mobile-nav-label">{t('nav.contact')}</span>
        </Link>

        {isAuthenticated && (
          <Link
            to="/profile"
            className={`mobile-nav-item ${isActive('/profile') || isActive('/settings') || isActive('/admin') ? 'active' : ''}`}
          >
            <div className="mobile-nav-icon">
              <i className="fas fa-user-circle"></i>
            </div>
            <span className="mobile-nav-label">{t('nav.profile')}</span>
          </Link>
        )}
      </div>
    </nav>
  );
};

export default MobileNav;
